import { get } from 'lodash';

import app from '../app';

app.service('latestBackendResponseService', [function() {
  this.data = {};
  this.conditions = [{
      checkMatch: (response) => {
        const url = get(response, 'config.url');
        if (url.indexOf('/publish-terms/') === -1) return;

        this.data.publishTerms = angular.copy(response.data.data);
      },
    }
  ];
}]);
